import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from 'view/common/with-async';

export const ServiceHubForm = withAsync({
    loader: lazyForPaint(() => {
        return import(/* webpackChunkName: "service-hub-form" */ './service-hub-form');
    }),
});
